<template>
    <div class="fill-the-gaps-container">
        <div class="confirm-location">
            <p class="title">YOUR LOCATION</p>
            <div class="map">
                <div ref="google-map" id="google-map"></div>
                <div class="position-relative d-flex flex-column">
                    <input
                        ref="autocomplete"
                        v-model="formData.location"
                        name="location"
                        type="text"
                    />
                    <div v-if="!formData.location" class="example-location">
                        <div class="d-flex align-items-center mb-4">
                            <img :src="getIcon() + 'location-icon.png'" alt="" />
                            <p class="example-text-location">Suggestion Starting to type123</p>
                        </div>
                        <div class="d-flex align-items-center mb-4">
                            <img :src="getIcon() + 'location-icon.png'" alt="" />
                            <p class="example-text-location">Suggestion ABC-1</p>
                        </div>
                        <div class="d-flex align-items-center mb-4">
                            <img :src="getIcon() + 'location-icon.png'" alt="" />
                            <p class="example-text-location">Suggestion ABC-2</p>
                        </div>
                    </div>
                    <input
                        type="text"
                        class="venue-name-form"
                        placeholder="Venue name"
                        v-model="formData.venue_name"
                    />
                </div>
            </div>
            <div class="step-action">
                <button :disabled="isContinueDisabled" @click="goToNextStep" class="next-step">
                    CONTINUE
                </button>
                <p @click="goToPrevPage" class="back-step-budget-btn">Back</p>
            </div>
        </div>
    </div>
</template>

<script>
    import Google from '@/constants/google'

    export default {
        name: 'VenueLocationRegistration',
        data: () => ({
            formData: {
                location: '',
                lat: null,
                lng: null,
                venue_name: ''
            },
            mapData: {
                map: null,
                autocomplete: null
            },
            apiLoaded: false,
            checkInterval: null
        }),
        methods: {
            initialize() {
                // eslint-disable-next-line
                this.mapData.map = new google.maps.Map(this.$refs['google-map'], Google.DEFAULT_MAP_OPT)

                // eslint-disable-next-line
                this.mapData.autocomplete = new google.maps.places.Autocomplete(
                    this.$refs['autocomplete'],
                    {
                        fields: ['geometry', 'formatted_address']
                    }
                )

                this.mapData.autocomplete.addListener('place_changed', this.onPlaceChanged)
            },

            onPlaceChanged() {
                let place = this.mapData.autocomplete.getPlace()

                if (place.geometry && place.formatted_address) {
                    let lat = place.geometry.location.lat()
                    let lng = place.geometry.location.lng()

                    this.mapData.map.panTo({ lat, lng })

                    this.formData.location = place.formatted_address
                    this.formData.lat = lat
                    this.formData.lng = lng
                }
            },

            goToNextStep() {
                console.log(this.formData)
                this.$emit('next', this.formData)
            },
            goToPrevPage() {
                this.$emit('prev')
            },
            handlePrevStep() {
                this.$emit('prev')
            },
            getIcon() {
                return '/images/'
            }
        },
        computed: {
            isContinueDisabled() {
                return this.formData.location ? false : true
            }
        },
        watch: {
            apiLoaded: function (loaded) {
                if (loaded) {
                    clearInterval(this.checkInterval)
                }
            }
        },
        mounted() {
            this.checkInterval = setInterval(() => {
                if (window.google) {
                    this.apiLoaded = true
                    this.initialize()
                }
            })
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../../../../sass/_variables.scss';
    .venue-name-form {
        border-radius: 100px;
        padding: 17px 30px;
        background-color: #ffffff00;
        margin-bottom: 15px;
        color: #ffffff;
        border: 1px solid #ffffff;
    }
    .example-location {
        position: absolute;
        top: 90px;
    }
    .back-step-budget-btn {
        font-family: Instrument Sans;
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 16px;
        text-align: center;
        letter-spacing: 1.25px;
        text-transform: uppercase;
        color: #ffffff;
        margin-top: 18px;
        cursor: pointer;
    }
    .example-text-location {
        font-family: Instrument Sans;
        font-style: normal;
        font-weight: 500;
        font-size: 14px;
        line-height: 24px;
        letter-spacing: -0.01em;
        color: #ffffff;
        margin-bottom: 0;
        margin-left: 25px;
    }
    .fill-the-gaps-container {
        flex: 0 0;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        .titles {
            order: 1;
            flex: 0 0 auto;

            .title {
                font-family: 'Instrument Sans';
                font-style: normal;
                font-weight: 600;
                font-size: 21px;
                line-height: 24px;
                letter-spacing: 3px;
                text-transform: uppercase;
                color: #ffffff;
            }

            .subtitle {
                margin-top: 15px;
                font-family: 'Instrument Sans';
                font-style: normal;
                font-weight: 400;
                font-size: 18px;
                line-height: 27px;
                letter-spacing: 3px;
                color: white;
                text-align: center;
            }
        }

        .confirm-location {
            order: 2;
            flex: 0 0 auto;
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            margin-top: 60px;
            border-radius: 20px;
            padding: 50px;
            gap: 74px;
            margin-bottom: 98px;

            .title {
                order: 1;
                flex: 0 0 auto;
                font-family: 'Instrument Sans';
                font-style: normal;
                font-weight: 500;
                font-size: 18px;
                line-height: 22px;
                text-align: center;
                letter-spacing: 0.1em;
                text-transform: uppercase;
                color: white;
            }

            .map {
                order: 2;
                flex: 0 0 auto;
                display: flex;
                flex-direction: row;
                gap: 70px;
                align-items: center;
                justify-content: center;

                #google-map {
                    width: 485px;
                    height: 416px;
                    border-radius: 15px;
                }

                input[name='location'] {
                    margin-bottom: 350px;
                    width: 607px;
                    height: 63px;
                    border: 1px solid #ffffff;
                    border-radius: 50px;
                    background: transparent;
                    color: white;
                    padding-left: 35px;
                    background-image: url(/images/icons/search_icon_white.png);
                    background-repeat: no-repeat;
                    background-position: 550px;
                    padding-left: 70px;
                    vertical-align: middle;
                }
            }
        }

        .media-upload {
            order: 3;
            flex: 0 0 auto;
            margin-top: 75px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;

            .view-carousel {
                flex: 0 0 auto;
                display: flex;
            }

            button {
                margin-bottom: 75px;
                display: flex;
                justify-content: center;
                align-items: center;
                width: 435px;
                height: 61px;
                background: #d7eb5a;
                border-radius: 40px;
                box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.17);
                font-family: 'Instrument Sans';
                color: #1b0d29;
                letter-spacing: 0.1em;
                text-transform: uppercase;
                font-style: normal;
                font-weight: 500;
                font-size: 18px;
                line-height: 22px;
            }

            p {
                font-family: 'Instrument Sans';
                font-style: normal;
                font-weight: 400;
                font-size: 18px;
                line-height: 27px;
                letter-spacing: 3px;
                color: white;
                margin-top: 25px;
                margin-bottom: 75px;
            }

            p.required-message {
                margin-top: -45px;
                margin-bottom: 75px;
            }
        }

        .step-action {
            order: 4;
            flex: 0 0 auto;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;

            .next-step {
                order: 1;
                flex: 0 0 auto;
                display: flex;
                justify-content: center;
                align-items: center;
                background: #d7eb5a;
                border-radius: 40px;
                box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.17);
                width: 435px;
                height: 61px;
                color: #1b0d29;
                font-family: 'Instrument Sans';
                font-style: normal;
                font-weight: 500;
                font-size: 18px;
                line-height: 22px;
                letter-spacing: 0.1em;
                text-transform: uppercase;
            }

            .next-step:disabled,
            .next-step[disabled] {
                background: #d7eb5a;
                border: 1px solid #d7eb5a;
                color: #000000;
            }

            .prev-step {
                order: 2;
                flex: 0 0 auto;
                font-family: Instrument Sans;
                font-style: normal;
                font-weight: 500;
                font-size: 14px;
                line-height: 16px;
                display: flex;
                align-items: center;
                text-align: center;
                letter-spacing: 1.25px;
                text-transform: uppercase;
                color: white;
                background: transparent;
                border: none;
                margin-top: 25px;
                margin-bottom: 50px;
            }
        }
    }
</style>
